import {
  Component,
  ContentChild,
  Directive,
  Input,
  TemplateRef,
} from '@angular/core';
import type { PriceGroup, PriceItem } from '@essent/new-customer';

@Directive({ selector: 'ng-template[wlPriceGroupAccordionHeader]' })
export class PriceGroupAccordionHeaderDirective {
  constructor(public templateRef: TemplateRef<any>) {}

  static ngTemplateContextGuard(
    _dir: PriceGroupAccordionHeaderDirective,
    _ctx: unknown
  ): _ctx is { $implicit: PriceGroup } {
    return true;
  }
}

@Directive({ selector: 'ng-template[wlPriceGroupAccordionContent]' })
export class PriceGroupAccordionContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}

  static ngTemplateContextGuard(
    _dir: PriceGroupAccordionHeaderDirective,
    _ctx: unknown
  ): _ctx is { $implicit: PriceItem } {
    return true;
  }
}

@Component({
  selector: 'wl-price-group-accordion[priceGroups]',
  templateUrl: './price-group-accordion.component.html',
  styleUrls: [
    './price-group-accordion.component.ed.scss',
    './price-group-accordion.component.essent.scss',
  ],
})
export class PriceGroupAccordionComponent {
  @ContentChild(PriceGroupAccordionHeaderDirective, { static: true })
  header?: PriceGroupAccordionHeaderDirective;
  @ContentChild(PriceGroupAccordionContentDirective, { static: true })
  content?: PriceGroupAccordionContentDirective;

  // All pricegroup interfaces coming from `@essent/some-package` differ and use different keys for yearly/monthly costs,
  // we opinionate towards the new-customer implementation and expose a helper function 'castToNewCustomerPriceGroup'
  // in order to attach input to this component. Maybe it can be made more usecase-agnostic in the future?
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() priceGroups!: PriceGroup[];
}
